/* eslint-disable no-console */
import { useEffect } from 'react';
import useAxios from 'axios-hooks';
import { getBaseUrl } from '../../utility';
import useXapi from '../../Hooks/useXapi';
import { useTranslation } from 'react-i18next';

// gets and appliues version to meta tag in head
const Version = ({ children }) => {
  const baseUrl = getBaseUrl();
  const { i18n } = useTranslation();
  const [{ data: version, error: loadError }] = useAxios(
    `${baseUrl}/release-version.json`
  );

  const { xApiEvent } = useXapi();
  // apply version if version file exists
  useEffect(() => {
    if (version) {
      document
        .querySelector('meta[version]')
        .setAttribute('version', version.version);
    }
  }, [version]);

  // log the error if version doesn't exist
  useEffect(() => {
    if (loadError) {
      console.log('Failed to load version info');
      console.log(loadError.response);
    }
  }, [loadError]);

  // trigger xAPI event for entering the UI
  // TODO: consider if this is the most appropriate place to put this
  useEffect(() => {
    if (i18n.language) {
      xApiEvent('Course Entered', window.location.href);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n]);

  // return children for UI display
  return children;
};

export default Version;
